import { Button } from "@babackapp/ui/components/button";
import { cn } from "@babackapp/ui/lib/utils";
import { sectionToParent, useThemeContextualColors } from "../../hooks";
import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { getThemeButtonStyle } from "./shared-button-styling";
import { ButtonBlockProps } from "./types";

export default function ButtonWeb({
  block,
  formatter,
  theme,
  locale,
  defaultLocale,
  section,
  isEditor,
  shop,
}: ButtonBlockProps & { isEditor?: boolean }) {
  const contentHTML =
    block.content?.[locale]?.text || block.content?.[defaultLocale]?.text;
  const alignment = block.alignment || "center";
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const href =
    block.content?.[locale]?.href || block.content?.[defaultLocale]?.href;

  let formattedText =
    !!formatter && contentHTML ? formatter(contentHTML) : contentHTML;
  const formattedHref = !!formatter && href ? formatter(href) : href;

  if (!formattedText?.length) {
    if (isEditor) {
      formattedText = "Ajoutez un label";
    } else {
      return null;
    }
  }

  const buttonStyle = getThemeButtonStyle({
    variant: block.properties?.variant || "default",
    theme,
    textColor: colors.text,
  });

  return (
    <EmailComponentWrapper shop={shop}>
      <div
        className={cn("flex", {
          "justify-center": alignment === "center",
          "justify-start": alignment === "left",
          "justify-end": alignment === "right",
        })}
      >
        <a href={formattedHref} target="_blank" rel="noopener noreferrer">
          <Button style={buttonStyle}>
            <span
              dangerouslySetInnerHTML={{
                __html: formattedText,
              }}
            />
          </Button>
        </a>
      </div>
    </EmailComponentWrapper>
  );
}
